import PhoneArea from "components/PhonePreview/PhoneArea"
import React from "react"

const ListPreview = ({ title = "", bgImage, bgColor, listItems = [] }) => {
  return (
    <PhoneArea>
      <div
        style={{
          backgroundImage: `url(${bgImage})`,
          backgroundColor: bgColor,
          width: "105%",
          height: "105%",
          backgroundSize: "cover",
          marginLeft: "-5px",
          backgroundPosition: "center center",
          boxShadow: "inset 0 0 0 500px rgb(0 0 0 / 50%)",
        }}
      >
        <div
          className="py-4"
          style={{ fontSize: "16px", textAlign: "center", color: "white" }}
        >
          {title}
        </div>
        {listItems.map((item, index) => (
          <div
            key={index}
            style={{
              backgroundColor: "black",
              width: "90%",
              height: "60px",
              margin: "10px 6px",
              borderRadius: "5px",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <div
              style={{
                display: "flex",
              }}
            >
              {item?.image && item?.image?.editedImage && (
                <img
                  src={item?.image?.editedImage}
                  style={{
                    width: "50px",
                    height: "50px",
                    marginTop: "5px",
                    marginLeft: "5px",
                  }}
                />
              )}
              <span className="ms-2 mt-1">
                <p
                  style={{
                    margin: "0px",
                    color: "white",
                    fontSize: "11px",
                  }}
                >
                  <b>{item?.line1}</b>
                </p>
                <p
                  style={{
                    color: "white",
                    margin: "0px",
                    fontSize: "11px",
                  }}
                >
                  {item?.line2}
                </p>
                <p
                  style={{
                    color: "white",
                    margin: "0px",
                    fontSize: "11px",
                  }}
                >
                  {item?.line3}
                </p>
              </span>
            </div>
            <i
              className="bx bxs-label font-size-22"
              style={{
                color: "white",
                alignSelf: "center",
                marginRight: "10px",
              }}
            />
          </div>
        ))}
      </div>
    </PhoneArea>
  )
}

export default ListPreview
